<template>
	<div>
		<el-form>
			<el-form-item>
				<el-tree :data="menus" show-checkbox node-key="id" :props="defaultProps" ref="tree" highlight-current
					@check-change="handleChange">
				</el-tree>
			</el-form-item>
			<el-form-item>
				<el-button @click="$router.back()">取消</el-button>
				<el-button type="primary" @click="handleSave">保存</el-button>
			</el-form-item>
		</el-form>
	</div>
</template>

<script>
import { detail, edit } from "@/api/permission/role";
import { list } from "@/api/permission/menu";
export default {
	data() {
		return {
			menus: [],
			keys: [],
			id: null,
			defaultProps: {
				label: "name",
				children: "childrenList",
			},
			form: {}
		}
	},
	mounted() {
		this.id = this.$route.query.id;
		this.getDetail();
		this.getMenus();
	},
	methods: {
		getMenus() {
			list().then(({ code, data, message }) => {
				if (code == 200) {
					this.menus = data;
				} else {
					this.$message.error(message);
				}
			})
		},
		getDetail() {
			detail(this.id).then(({ code, data, message }) => {
				if (code == 200) {
					this.keys = (data.menuList || []).map((item) => item.id);
					(data.menuList || []).forEach((x) => {
						if (x.childrenList && x.childrenList.length > 0) {
							this.keys = this.keys.filter(c => c !== x.id).concat(x.childrenList.map(b => b.id))
						}
					})
					this.form = data;
					console.log(this.keys);
					this.$refs.tree.setCheckedKeys(this.keys);
				} else {
					this.$message.error(message);
				}
			});
		},
		handleChange() {
			this.keys = this.$refs.tree.getCheckedKeys().concat(this.$refs.tree.getHalfCheckedKeys());
		},
		handleSave() {
			const params = {
				...this.form,
				menuIdList: this.keys,
			};
			params.id = this.id;
			edit(params).then(({ code, error }) => {
				if (code == 200) {
					this.$message.success("配置成功");
					this.$router.back();
				} else {
					this.$message.error(error.message);
				}
			});
		}
	}
}
</script>

<style></style>